/* @ngInject */
export default class FindAContractorCtrl {
  constructor(
    $sce,
    $scope,
    $timeout,
    $rootScope
  ) {
    this.$sce = $sce;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;

    this.init();
    this.activate();
  }

  async init() {
    this.isBusy = true;
  }

  async activate() {
    window.location.href = "https://www.pretor.co.za/contractors1.html";
  }
}
